import call from "../../../../service/http";
import FirmMembersConstants from "./FirmMembersConstants";
import SearchConstants from "../../../search/SearchConstants";

export default {
  namespaced: true,
  state: {
    firmMembers: [],
    searchResults: [],
    loadingSearch: false,
  },
  mutations: {
    SET_FIRM_MEMBERS: (state, payload) => {
      state.firmMembers = payload;
    },
    SET_SEARCH_RESULTS: (state, payload) => {
      state.searchResults = payload;
    },
    SET_LOADING_SEARCH: (state, payload) => {
      state.loadingSearch = payload;
    },
  },
  getters: {
    firmMembers: (state) => state.firmMembers,
    searchResults: (state) => state.searchResults,
    loadingSearch: (state) => state.loadingSearch,
  },
  actions: {
    searchMembers: ({ commit }, term) => {
      if (!term) {
        commit("SET_SEARCH_RESULTS", []);
        return;
      }
      commit("SET_LOADING_SEARCH", true);
      const query = {
        term: btoa(term.trim()),
        limit: 10,
        select: true,
      };
      call("get", SearchConstants.search(query))
        .then((res) => {
          commit("SET_SEARCH_RESULTS", res.data.data.data);
          commit("SET_LOADING_SEARCH", false);
        })
        .catch(() => {
          commit("SET_LOADING_SEARCH", false);
        });
    },

    getFirmMembers: ({ commit }) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null, { root: true });
      call("get", FirmMembersConstants.firmMembers)
        .then((res) => {
          commit("SET_FIRM_MEMBERS", res.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message:
                err.response?.data?.message || "Failed to fetch firm members",
            },
            { root: true }
          );
        });
    },

    addFirmMember: ({ commit, dispatch }, data) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null, { root: true });
      call("post", FirmMembersConstants.firmMembers, data)
        .then(() => {
          dispatch("getFirmMembers");
          // Event.$emit("application-checklist"); // Emit if checklist update is needed
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message:
                err.response?.data?.message || "Failed to add firm member",
            },
            { root: true }
          );
        });
    },

    updateFirmMember: ({ commit, dispatch }, data) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null, { root: true });
      call("post", FirmMembersConstants.update, data)
        .then(() => {
          dispatch("getFirmMembers");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message:
                err.response?.data?.message || "Failed to update firm member",
            },
            { root: true }
          );
        });
    },

    removeFirmMember: ({ commit, dispatch }, data) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null, { root: true });
      call("post", FirmMembersConstants.remove, data)
        .then(() => {
          dispatch("getFirmMembers");
          // Event.$emit("application-checklist");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit(
            "SET_ALERT",
            {
              status: "error",
              message:
                err.response?.data?.message || "Failed to remove firm member",
            },
            { root: true }
          );
        });
    },
  },
};
